module.exports = __webpack_public_path__ + "9604b84da8c28bd702ade50f0a55cf79.png";